import React from "react";
import styled from "styled-components";
import { colors, causeColors } from "./colors";

export default function CauseTag({ cause }) {
    return (
        <Tag>
            <Square $color={causeColors[cause]} />
            {cause}
        </Tag>
    );
}

const Tag = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    font-size: 13px;
    color: ${colors.ink};
`;

export const Square = styled.span`
    width: 8px;
    height: 8px;
    border-radius: 2px;
    flex-shrink: 0;
    background: ${({ $color }) => $color};
`;
